import React from "react";
import { useSelector } from "react-redux";
import BlogPart from "../../components/Blog/HomeBlogSection";
import Loader from "../../Loader";
import { fixImagePaths } from "../../components/util";

const Blog = () => {
  const { page } = useSelector((state) => state.data);

  if (!page || !page.data) {
    return <Loader />;
  }

  // const htmlContent = fixImagePaths(page.data["blogs"]?.htmlContent || "");

  return (
    <div id="rs-blog" className="rs-blog pt-108 pb-120 md-pt-70 md-pb-70">
      <div className="container">
        <BlogPart />
      </div>
    </div>
  );
};

export default Blog;
